<template>
<section class="wikiContents" data-editor-active :data-depth="depth" :data-parent-type="parentType">
  
  <div v-if="editor.step == 0" class="contentStep1">
    <h1 class="title" ref="title" :data-title="editor.key">
      {{`${editor.title || editor.text}`}}
    </h1>
    <div class="contents" v-html="editor.content"></div>
  </div>
  <div v-if="editor.step == 1" class="contentStep2">
    <h2>{{`${editor.title || editor.text}`}}</h2>
    <div class="contentWrap">
      <div class="contents" v-html="editor.content"></div>
      <div class="contentStep3">
        <wikiContent v-if="editor.child" v-for="(child, index) in editor.child" :editor="child" :depth="depth+1"
          :position="positionSet"
          :index="index"
          :parentType="getParentType"
        >
        </wikiContent>
      </div>
    </div>
  </div>
  <div v-if="editor.step >= 2" class="contentStep3">
    <h3>{{ editor.title }}</h3>
    <div class="contents" v-html="editor.content"></div>
    <wikiContent v-if="editor.child" v-for="(child, index) in editor.child" :editor="child" :depth="depth+1"
        :position="positionSet"
        :index="index"
        :parentType="getParentType"
      >
    </wikiContent>
  </div>
  <wikiContent v-if="editor.step <= 0 && editor.child" v-for="(child, index) in editor.child" :editor="child" :depth="depth+1"
    :position="positionSet"
    :index="index"
    :parentType="getParentType"
  >
  </wikiContent>
  
</section>
</template>

<script>
export default {
  name: 'wikiContent',
  props: {
    editor: {
			type: Object,
			default() { return {} }
		},
		depth: {
			type: Number,
			default() { return 0 }
		},
		index: {
			type: Number,
			default() { return 0 }
		},
		position: {
			type: Array,
			default() { 
				return [0] 
			}
		},
    parentType: {
      type: String,
      default: ''
    }
  },
  data() {
    return{
      flipStatus: true,
      
    }
  },
  computed: {
    positionSet() {
			this.position[this.depth] = this.index;
			return this.position.slice();
		},
    getParentType() {
      let types = 'P,R,C,D,M,V,L,H,T';
      return types.split(',').filter( type=> this.editor[type] === true ).join(';');
    }
  },
  async mounted() {
    if(document.getElementsByTagName('img')){
      for(let imgTag of document.getElementsByTagName('img')) {
        if(imgTag.src.indexOf('https://analysis.kist.re.kr/') > -1){
          const response = await axios.get(imgTag.src, {responseType: "blob"});
          var reader = new FileReader();
          reader.onload = function(e) {
            imgTag.src = reader.result;
          }
          reader.readAsDataURL(response.data);
        }
      }
    }
    this.$emit('mouned', {

		})
  },
  methods: {
    flipChild (data) {
			this.flipStatus = !this.flipStatus
			this.flip( this.flipStatus, this.editor, this.step )
			this.$emit('flip-content', {
				status: this.flipStatus,
				editor: this.editor,
				step: this.step
			})
		},
  }
}
</script>
<style lang="scss" scoped>
.wikiContents {
  h1, h2, h3 {
    position: relative; top:0; left:0;
    color: #333; font-weight: 600; 
  }
  &[data-depth='0'] {
    
  }
  &[data-depth='1'] {
    border: 1px solid #ddd;
    &+[data-depth='1'] {
      border-top:0;
    }
  }
  [data-depth='2'] {
    padding: 12px;
    border: 1px solid #ddd;
    &+[data-depth='2'] { margin-top: 8px; }
  }
  &[data-parent-type='T'] { border: none; }
  .contents {
    position: relative; top:0; left:0;
    line-height: 1.5;
    img {
      margin: 8px 0;
    }
  }
}
.contentStep1 {
  padding: 12px;
  h1 {
    font-size: 20px; font-weight: 600;
  }
}
.contentStep2 {
  display: flex;
  
  h2 {
    flex-shrink: 0;
    width: 180px; text-align: center;
    padding: 24px 24px 24px;
    border-right: 1px solid #ddd;
    background-color: #fbfbfb;
  }
  .contentWrap {
    width: 100%;
    padding: 12px 16px;
  }
  .contentStep3 {
    h3 + .contents {
      margin-top: 8px;
    }
  }
}

</style>